import { render, staticRenderFns } from "./DogovorOferty.vue?vue&type=template&id=79ea8728"
import script from "./DogovorOferty.vue?vue&type=script&lang=js"
export * from "./DogovorOferty.vue?vue&type=script&lang=js"
import style0 from "./DogovorOferty.vue?vue&type=style&index=0&id=79ea8728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports